import { connect } from "react-redux";
import ResetPassword from "./ResetPassword.query";
import { mapStateToProps, mapDispatchToProps } from "./ResetPassword.state";

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
